import { Dashicon } from "@wordpress/components";
import { useLocation } from "react-router-dom";
import { noLayouts as noLayoutsIcon } from "../Icons";
import {__} from '@wordpress/i18n';

const NoLayout = ({source = ''}) => {
  const location = useLocation();
  const pathMap = {
    "/header": "Header",
    "/footer": "Footer",
    "/404": "404",
  };

  const page = pathMap[location.pathname];

  return (
    <>
      <div className="flex justify-center items-center flex-col mt-28">
        <div>{noLayoutsIcon}</div>
        <div className="mt-9 mb-8">
          <p className="text-center text-[#333333] font-semibold text-lg mb-2">
            {__( 'No Layouts Found', 'responsive-addons' )}
          </p>
          <p className="text-center text-[#333333] font-light text-sm">
            {__( 'No templates found for' , 'responsive-addons' )} {page}. {__( 'Want to create one?...', 'responsive-addons' )}
          </p>
        </div>
        <div>
          <button
            onClick={() => window.location.href = responsive_addons_site_builder?.admin_url + 'post-new.php?post_type=resp-site-builder&type=' + source}
            className="flex gap-2 pr-[14px] pl-[14px] py-2.5 text-white bg-btnPrimary hover:bg-sky-600 rounded"
          >
            <Dashicon icon="plus-alt2" />
            {__( 'Create New', 'responsive-addons' )}
          </button>
        </div>
      </div>
    </>
  );
};

export default NoLayout;
